import { EdcTerminalUpdatePage } from "@/features/edc-terminal/pages/EdcTerminalUpdate";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/edc-terminal/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["edc_terminals.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: EdcTerminalUpdatePage,
});
